'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('../../style/index.css');

require('../../style/select.css');

var _CommentVisibilityOption = require('./CommentVisibilityOption');

var _CommentVisibilityOption2 = _interopRequireDefault(_CommentVisibilityOption);

var _renderCoamMentionSuggestion = require('../renderers/renderCoamMentionSuggestion');

var _renderCoamMentionSuggestion2 = _interopRequireDefault(_renderCoamMentionSuggestion);

var _visibility = require('../tools/visibility');

var _reactMentions = require('react-mentions');

var _reactComponents = require('@cimpress/react-components');

var _cimpressCustomizr = require('cimpress-customizr');

var _i18n = require('../tools/i18n');

var _reactI18next = require('react-i18next');

var _helper = require('../tools/helper');

var _mentions = require('../clients/mentions');

var _reactBaywatch = require('@cimpress-technology/react-baywatch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNewCommentForm = function (_React$Component) {
    _inherits(AddNewCommentForm, _React$Component);

    function AddNewCommentForm(props) {
        _classCallCheck(this, AddNewCommentForm);

        var _this = _possibleConstructorReturn(this, (AddNewCommentForm.__proto__ || Object.getPrototypeOf(AddNewCommentForm)).call(this, props));

        _this.customizrClient = new _cimpressCustomizr.CustomizrClient({
            resource: 'https://comment.trdlnk.cimpress.io/'
        });

        _this.jwtSub = (0, _helper.getSubFromJWT)(_this.props.accessToken);

        _this.state = {
            commentToAdd: props.initialValue || '',
            alertDismissed: true,
            commentVisibilityLevels: (0, _visibility.getVisibilityLevels)(_this.tt.bind(_this)),
            selectedVisibilityOption: null,
            userAccessLevel: null
        };
        return _this;
    }

    _createClass(AddNewCommentForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._ismounted = true;
            this.init();
            this.resetSelectedVisibilityOption();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _this2 = this;

            var commentVisibilityLevels = JSON.stringify(this.state.commentVisibilityLevels);
            var newCommentVisibilityLevels = JSON.stringify((0, _visibility.getVisibilityLevels)(this.tt.bind(this)));
            if (commentVisibilityLevels !== newCommentVisibilityLevels) {
                newCommentVisibilityLevels = JSON.parse(newCommentVisibilityLevels);
                var newSelectedVisibilityOption = this.state.selectedVisibilityOption ? newCommentVisibilityLevels.find(function (x) {
                    return x.value === _this2.state.selectedVisibilityOption.value;
                }) : null;
                this.setState({
                    commentVisibilityLevels: newCommentVisibilityLevels,
                    selectedVisibilityOption: newSelectedVisibilityOption
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._ismounted = false;
        }
    }, {
        key: 'safeSetState',
        value: function safeSetState(data, callback) {
            if (this._ismounted) {
                this.setState(data, callback);
            }
        }
    }, {
        key: 'init',
        value: function init() {
            var _this3 = this;

            // Get the settings (it won't make a network call as the data is cached!
            this.customizrClient.getSettings(this.props.accessToken).then(function (json) {
                var newAlertDismissed = json.mentionsUsageNotification && json.mentionsUsageNotification.alertDismissed === true;
                var newSelectedVisibilityOption = _this3.state.commentVisibilityLevels.find(function (l) {
                    return l.value === (_this3.props.enforceVisibilityLevel || json.selectedVisibility);
                });
                // Only update the state if there is change
                if (_this3.state.alertDismissed !== newAlertDismissed || _this3.state.selectedVisibilityOption !== newSelectedVisibilityOption) {
                    _this3.safeSetState({
                        alertDismissed: newAlertDismissed,
                        selectedVisibilityOption: newSelectedVisibilityOption
                    }, function () {
                        _this3.resetSelectedVisibilityOption();
                    });
                }
            });
        }
    }, {
        key: 'resetSelectedVisibilityOption',
        value: function resetSelectedVisibilityOption() {
            var _this4 = this;

            var newCommentVisibilityLevels = (0, _visibility.getVisibilityLevels)(this.tt.bind(this), this.state.userAccessLevel);
            var narrowestAvailableVisibilityOptionIndex = newCommentVisibilityLevels.every(function (l) {
                return !l.disabled;
            }) ? newCommentVisibilityLevels.length - 1 : newCommentVisibilityLevels.findIndex(function (l) {
                return l.disabled;
            }) - 1;

            var preferredVisibilityOptionIndex = this.state.selectedVisibilityOption ? newCommentVisibilityLevels.findIndex(function (l) {
                return l.value === _this4.state.selectedVisibilityOption.value;
            }) : newCommentVisibilityLevels.length - 1;

            var selectedVisibilityOptionIndex = Math.min(narrowestAvailableVisibilityOptionIndex, preferredVisibilityOptionIndex);

            if (this.state.commentVisibilityLevels !== newCommentVisibilityLevels || this.state.selectedVisibilityOption !== newCommentVisibilityLevels[selectedVisibilityOptionIndex]) {
                this.safeSetState({
                    commentVisibilityLevels: newCommentVisibilityLevels,
                    selectedVisibilityOption: newCommentVisibilityLevels[selectedVisibilityOptionIndex]
                });
            }
        }
    }, {
        key: 'onAlertDismissed',
        value: function onAlertDismissed() {
            this.customizrClient.putSettings(this.props.accessToken, {
                mentionsUsageNotification: {
                    alertDismissed: true
                }
            });
            this.safeSetState({
                alertDismissed: true
            });
        }
    }, {
        key: 'tt',
        value: function tt(key) {
            // eslint-disable-next-line react/prop-types
            var _props = this.props,
                t = _props.t,
                locale = _props.locale;

            if (locale.length > 2) {
                locale = locale.substr(0, 2);
            }
            return t(key, { lng: locale });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var postComment = function postComment(locality) {
                return function (key) {
                    locality.props.onPostComment(locality.state.commentToAdd, locality.state.selectedVisibilityOption.value).then(function () {
                        return locality.safeSetState({ commentToAdd: '' });
                    });
                };
            };

            var watchLink = _react2.default.createElement(_reactBaywatch.WatchLabel, { accessToken: this.props.accessToken, resourceUri: this.props.commentsClient.getResourceUri(),
                locale: this.props.locale, labelOnSubscriptionActive: this.props.textOverrides.unsubscribe || this.tt('stop_watching_this_thread'),
                labelOnSubscriptionInactive: this.props.textOverrides.subscribe || this.tt('watch_this_thread') });

            var postButton = _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-primary',
                    disabled: !this.props.resourceUri || this.state.commentToAdd.trim() === '' || !this.state.selectedVisibilityOption,
                    onClick: postComment(this) },
                this.props.textOverrides.postComment || this.tt('btn_post')
            );

            var visibilityLevels = _react2.default.createElement(
                'div',
                { style: { display: 'table' } },
                _react2.default.createElement(_reactComponents.Select, {
                    label: this.tt('show_my_comment_to'),
                    value: this.state.selectedVisibilityOption,
                    options: this.state.commentVisibilityLevels,
                    onChange: function onChange(selectedVisibilityOption) {
                        _this5.customizrClient.putSettings(_this5.props.accessToken, { selectedVisibility: selectedVisibilityOption.value });
                        _this5.safeSetState({ selectedVisibilityOption: selectedVisibilityOption });
                    },
                    searchable: false,
                    clearable: false,
                    optionComponent: _CommentVisibilityOption2.default
                }),
                _react2.default.createElement(
                    'span',
                    { className: 'input-group-btn', style: { display: 'table-cell' } },
                    postButton
                )
            );

            return _react2.default.createElement(
                'div',
                {
                    className: 'comments-add',
                    onKeyDown: (0, _helper.performActionOnMetaEnter)(postComment(this)),
                    tabIndex: '0' },
                _react2.default.createElement(
                    'div',
                    { className: 'comments-alert' },
                    _react2.default.createElement(_reactComponents.Alert, {
                        type: 'info',
                        message: _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactI18next.Trans, {
                                defaults: this.tt('use_at_char_for_mentions')
                                // eslint-disable-next-line react/jsx-key
                                , components: [_react2.default.createElement(
                                    'strong',
                                    null,
                                    '@'
                                )]
                            })
                        ),
                        dismissible: true,
                        dismissed: this.state.alertDismissed,
                        onDismiss: this.onAlertDismissed.bind(this)
                    })
                ),
                this.props.newestFirst ? null : watchLink,
                _react2.default.createElement(
                    'div',
                    { className: this.props.showVisibilityLevels ? null : 'post-button-inline' },
                    _react2.default.createElement(
                        _reactMentions.MentionsInput,
                        {
                            autoFocus: this.props.autoFocus,
                            className: 'mentions mentions-min-height',
                            value: this.state.commentToAdd,
                            onChange: function onChange(e, newValue) {
                                return _this5.safeSetState({ commentToAdd: newValue });
                            },
                            displayTransform: function displayTransform(id, display, type) {
                                return '@' + display;
                            }, allowSpaceInQuery: true,
                            placeholder: this.props.textOverrides.placeholder },
                        _react2.default.createElement(_reactMentions.Mention, {
                            trigger: '@',
                            data: function data(search, callback) {
                                (0, _mentions.fetchMatchingMentions)(_this5.props.accessToken, search).then(callback);
                            },
                            renderSuggestion: _renderCoamMentionSuggestion2.default
                        })
                    ),
                    this.props.showVisibilityLevels ? null : postButton
                ),
                this.props.showVisibilityLevels ? visibilityLevels : null,
                this.props.newestFirst ? watchLink : null
            );
        }
    }]);

    return AddNewCommentForm;
}(_react2.default.Component);

AddNewCommentForm.propTypes = {
    locale: _propTypes2.default.string,
    accessToken: _propTypes2.default.string.isRequired,
    resourceUri: _propTypes2.default.string.isRequired,
    initialValue: _propTypes2.default.string,
    newestFirst: _propTypes2.default.bool,
    onPostComment: _propTypes2.default.func,
    commentsClient: _propTypes2.default.any,
    showVisibilityLevels: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    enforceVisibilityLevel: _propTypes2.default.oneOf(['public', 'internal']),
    textOverrides: _propTypes2.default.shape({
        placeholder: _propTypes2.default.string,
        subscribe: _propTypes2.default.string,
        unsubscribe: _propTypes2.default.string,
        postComment: _propTypes2.default.string
    })
};

AddNewCommentForm.defaultProps = {
    locale: 'en',
    autoFocus: true
};

exports.default = (0, _reactI18next.translate)('translations', { i18n: (0, _i18n.getI18nInstance)() })(AddNewCommentForm);